import { Box, Typography } from '@mui/material';

interface Props {
  title: string;
  children: React.ReactNode;
}

function Section({ title, children }: Props) {
  return (
    <Box>
      <Typography
        variant='caption'
        color='text.secondary'
        sx={{ fontWeight: 600 }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          mt: 0.5,
          p: 1,
          bgcolor: 'action.hover',
          borderRadius: 1,
          fontSize: 13,
          whiteSpace: 'pre-wrap',
          maxHeight: 240,
          overflow: 'auto',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

export default Section;
